import React, { useState, useEffect } from 'react';
import Navbar from './Navbar';

const CommunityPage = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="relative min-h-screen bg-[#f5f3f0]">
      <Navbar textColor="green" logoVariant="green" hoverColor="copper" />

      <main className="relative z-10 min-h-screen px-6 py-32 md:py-40 lg:px-16">
        <div
          className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${
            isLoaded ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
          }`}
        >
          {/* Top Section */}
          <div className="mb-16 max-w-5xl lg:max-w-[50%]">
            <h1
              className="text-[#e4a483] text-xs md:text-sm tracking-[0.4em] font-medium uppercase mb-4"
              style={{ fontFamily: "'Figtree', sans-serif" }}
            >
              Experience
            </h1>

            <p
              className="text-[#1a441f] text-4xl md:text-5xl lg:text-6xl leading-tight font-light mb-12"
              style={{ fontFamily: "'Spirits Soft', serif" }}
            >
              Bridging the gap between knowing and being.
            </p>

            <p
              className="text-[#36454f] text-lg md:text-xl leading-relaxed font-light max-w-3xl"
              style={{ fontFamily: "'Figtree', sans-serif" }}
            >
              Membership in GWS means being part of a journey to bridge the gap between knowing and being.
            </p>
          </div>

          {/* Three Column Grid */}
          <div className="grid md:grid-cols-3 gap-16 lg:gap-20 relative">
            {/* The GWS App */}
            <div className="flex flex-col gap-6">
              <span
                className="text-[#e4a483]/80 text-sm tracking-[0.3em] font-medium"
                style={{ fontFamily: "'Figtree', sans-serif" }}
              >
                01
              </span>
              <h2
                className="text-[#1a441f] text-2xl md:text-3xl font-light tracking-tight"
                style={{ fontFamily: "'Spirits Soft', serif" }}
              >
                The GWS App
              </h2>
              <div className="space-y-4">
                <p
                  className="text-[#36454f] text-[1rem] leading-relaxed font-light"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  Our private app is the digital house of The Society. Members can register for gatherings and events, connect with other members.
                </p>
                <p
                  className="text-[#36454f] text-[1rem] leading-relaxed font-light"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  Within the app, our News & Insights Agent shares global reports, economic developments, and relevant geopolitical shifts weekly to keep our members updated and informed.
                </p>
              </div>
            </div>

            {/* Vertical divider after 01 */}
            <div className="hidden md:block absolute left-1/3 top-0 bottom-0 w-px bg-[#e4a483]/20" />

            {/* Social Gatherings */}
            <div className="flex flex-col gap-6">
              <span
                className="text-[#e4a483]/80 text-sm tracking-[0.3em] font-medium"
                style={{ fontFamily: "'Figtree', sans-serif" }}
              >
                02
              </span>
              <h2
                className="text-[#1a441f] text-2xl md:text-3xl font-light tracking-tight"
                style={{ fontFamily: "'Spirits Soft', serif" }}
              >
                Social Gatherings
              </h2>
              <div className="space-y-4">
                <p
                  className="text-[#36454f] text-[1rem] leading-relaxed font-light"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  Throughout the year, we host private dinners, Intergenerational Talks, Business Tables, member-hosted events, travel programmes, cultural dialogues, game nights, and sports activities.
                </p>
                <p
                  className="text-[#36454f] text-[1rem] leading-relaxed font-light"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  Although the schedule and number of gatherings vary, we make sure to create as many reasons as possible to come together.
                </p>
              </div>
            </div>

            {/* Vertical divider after 02 */}
            <div className="hidden md:block absolute left-2/3 top-0 bottom-0 w-px bg-[#e4a483]/20" />

            {/* Growth Sessions */}
            <div className="flex flex-col gap-6">
              <span
                className="text-[#e4a483]/80 text-sm tracking-[0.3em] font-medium"
                style={{ fontFamily: "'Figtree', sans-serif" }}
              >
                03
              </span>
              <h2
                className="text-[#1a441f] text-2xl md:text-3xl font-light tracking-tight"
                style={{ fontFamily: "'Spirits Soft', serif" }}
              >
                Growth Sessions
              </h2>
              <div className="space-y-4">
                <p
                  className="text-[#36454f] text-[1rem] leading-relaxed font-light"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  We organize closed-door sessions with experts around themes that matter to next-generation family members, including governance, structuring, succession and leadership transitions, capital allocation and alternative investments.
                </p>
                <p
                  className="text-[#36454f] text-[1rem] leading-relaxed font-light"
                  style={{ fontFamily: "'Figtree', sans-serif" }}
                >
                  We provide access to global summits in the wealth management and family office ecosystem. We offer ongoing cognitive training programs designed to strengthen decision-making and executive function.
                </p>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default CommunityPage;
